var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"logout-btn"},[_c('div',{style:({ visibility: (_vm.clicksToTurnDev < 4 ? 'visible' : 'hidden') })},[_vm._v(_vm._s(_vm.$t('common.click_to_logout', { n: _vm.clicksToTurnDev })))]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.version))])
}]

export { render, staticRenderFns }